import {ITts} from './ITts';
import axios from 'axios';

export class Tts implements ITts {
  apiEndpoint: string = "https://northamerica-northeast1-alloprof-stg.cloudfunctions.net/textToSpeechProxy/";

  constructor(public ttsApiEndpoint: string) {
    this.apiEndpoint = ttsApiEndpoint;
  }

  async get(text: string, lang: string): Promise<any> {
    let response = await axios({
      method: 'POST',
      url: this.apiEndpoint,
      data: {
        text, lang
      },
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  }
}
